module.exports = __webpack_public_path__ + "static/img/site1.889cfad.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/site1.gif
// module id = 3gXR
// module chunks = 1